import { createSlice } from '@reduxjs/toolkit';
export const initialState = {};
export const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    setExperimentEnrolmentEligibility: (state, action) => {
      state[action.payload.experimentKey].enrolmentEligibility = action.payload.isEligible;
    }
  }
});
export const {
  setExperimentEnrolmentEligibility
} = experimentsSlice.actions;
export default experimentsSlice.reducer;